import { render, staticRenderFns } from "./EventsHistory.vue?vue&type=template&id=c0f845ae&scoped=true&"
import script from "./EventsHistory.vue?vue&type=script&lang=js&"
export * from "./EventsHistory.vue?vue&type=script&lang=js&"
import style0 from "./EventsHistory.vue?vue&type=style&index=0&id=c0f845ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f845ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0f845ae')) {
      api.createRecord('c0f845ae', component.options)
    } else {
      api.reload('c0f845ae', component.options)
    }
    module.hot.accept("./EventsHistory.vue?vue&type=template&id=c0f845ae&scoped=true&", function () {
      api.rerender('c0f845ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/events/EventsHistory.vue"
export default component.exports